import JsCookie from 'js-cookie';
import {
  HIDE_DOWNLOAD_APP_BANNER,
  HIDE_PERMISSIONS_BANNER,
  SAVE_LAST_SEARCH,
} from '../Index/constants';
import {
  SUSCRIPTION_USER_HAS_DISALLOW_PUSH,
  SUSCRIPTION_USER_SUCCESS,
  RESTORE_USER_SUBSCRIPTION_SUCCESS,
  TRACKING_PERMISSIONS_CUSTOM_AUTO_DISALLOW,
} from '../Notifications/constants';
import {
  COOKIE_TROVIT_SHOW_DOWNLOAD_APP_BANNER,
  COOKIE_TROVIT_SHOW_PERMISSIONS_BANNER_COUNTER,
  COOKIE_TROVIT_IS_PUSH_DISALLOW,
  COOKIE_TROVIT_LAST_SEARCH,
  COOKIE_TROVIT_PERSONALIZED_GOOGLE_ADS,
  COOKIE_TROVIT_SHOW_GDPR_COOKIE_BANNER,
} from '../cookies';
import { DISABLE_PERSONALIZED_GOOGLE_ADS, HIDE_GDPR_COOKIE_BANNER } from '../Gdpr/actionTypes';
import { trackEvent } from '../tracking/actions';
import { notificationPermissionsEvent } from '../tracking/events';

// eslint-disable-next-line no-unused-vars
const cookies = store => next => action => {
  // dispatch the middleaction so we have the updated state below
  const result = next(action);

  // The user has closed the GDPR advice
  if (action.type === HIDE_GDPR_COOKIE_BANNER) {
    JsCookie.set(COOKIE_TROVIT_SHOW_GDPR_COOKIE_BANNER, 0, { expires: 365 });
  }

  // The user has disallowed personalized Google ads
  if (action.type === DISABLE_PERSONALIZED_GOOGLE_ADS) {
    JsCookie.set(COOKIE_TROVIT_PERSONALIZED_GOOGLE_ADS, 0, { expires: 365 });
  }

  // The user has closed the download banner
  if (action.type === HIDE_DOWNLOAD_APP_BANNER) {
    JsCookie.set(COOKIE_TROVIT_SHOW_DOWNLOAD_APP_BANNER, false);
  }

  // The user has closed the web push notifications permissions banner (custom)
  if (action.type === HIDE_PERMISSIONS_BANNER) {
    const showPermissionsBannerCounter = store.getState().config.showPermissionsBannerCounter;
    if (showPermissionsBannerCounter >= 3) {
      JsCookie.set(COOKIE_TROVIT_IS_PUSH_DISALLOW, true, { expires: 7 });
    }
    // If showPermissionsBannerCounter === 3 is cause the user close the dialog 3 times (if he blocked it would be === 100)
    if (showPermissionsBannerCounter === 3) {
      store.dispatch(
        trackEvent(notificationPermissionsEvent(TRACKING_PERMISSIONS_CUSTOM_AUTO_DISALLOW))
      );
    }
    JsCookie.set(COOKIE_TROVIT_SHOW_PERMISSIONS_BANNER_COUNTER, showPermissionsBannerCounter, {
      expires: 7,
    });
  }

  // The user has disallowed push notification permissions
  if (action.type === SUSCRIPTION_USER_HAS_DISALLOW_PUSH) {
    JsCookie.set(COOKIE_TROVIT_IS_PUSH_DISALLOW, true);
  }

  // The user has given permissions, so we should show the banner any longer
  if (
    action.type === SUSCRIPTION_USER_SUCCESS ||
    action.type === RESTORE_USER_SUBSCRIPTION_SUCCESS
  ) {
    JsCookie.set(COOKIE_TROVIT_IS_PUSH_DISALLOW, false);
    JsCookie.set(COOKIE_TROVIT_SHOW_PERMISSIONS_BANNER_COUNTER, 3);
  }

  // Save last search url to set in back button link because in redirection the app loses the referrer
  if (action.type === SAVE_LAST_SEARCH) {
    const EXPIRATION_TIME_30_MIN = new Date(new Date().getTime() + 30 * 60 * 1000);
    JsCookie.set(COOKIE_TROVIT_LAST_SEARCH, action.payload || '', {
      expires: EXPIRATION_TIME_30_MIN,
    });
  }

  return result;
};

export default cookies;



// WEBPACK FOOTER //
// ./app/middlewares/cookies.js